import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import { push } from "connected-react-router"
import {
  GET_TEMPLATE_COLLABORATORS_WATCHER,
  UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
  GET_TEMPLATE_CEASED_WATCHER,
  UPLOAD_TEMPLATE_CEASED_WATCHER,
  GET_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
  UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
  GET_TEMPLATE_TEAMS_WATCHER,
  UPLOAD_TEMPLATE_TEAMS_WATCHER,
} from "./constants"
import {
  getTemplateCollaboratorsSuccess,
  getTemplateCollaboratorsFailed,
  uploadTemplateCollaboratorsFailed,
  uploadTemplateCollaboratorsSuccess,
  getTemplateCeasedSuccess,
  getTemplateCeasedFailed,
  uploadTemplateCeasedSuccess,
  uploadTemplateCeasedFailed,
  getTemplateDivisionsAssignmentSuccess,
  getTemplateDivisionsAssignmentFailed,
  uploadTemplateDivisionsAssignmentSuccess,
  uploadTemplateDivisionsAssignmentFailed,
  getTemplateTeamsSuccess,
  getTemplateTeamsFailed,
  uploadTemplateTeamsSuccess,
  uploadTemplateTeamsFailed,
} from "./actions"
import {
  exportCollaboratorSegment,
  importCollaboratorSegment,
} from "../../utils/segment/Employee/employeeTrack"

import { woopraTrack } from "../../utils/woopra/woopraTracker"
import {
  KEY_TIMESTAMP_COLLABORATORS_IMPORT,
  LOCAL_COMPANY_ID,
  LOCAL_TOKEN,
  setItem,
} from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// GET EXCEL
export function getTemplateCollaboratorsApi(isTemplate) {
  woopraTrack("Descargar plantilla Colaboradores")
  const template = isTemplate ? "/template" : ""
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/export/xlsx${template}`,
  })
}

export function getTemplateTeamsApi(isTemplate) {
  woopraTrack("Descargar plantilla equipos")
  const template = isTemplate ? "/template" : ""
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/export/xlsx${template}`,
  })
}

function getTemplateCollaboratorsApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/export/xlsx/progress`,
  })
}

function getTemplateTeamsApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/export/xlsx/progress`,
  })
}



function donwloadTemplateCollaborators(url) {
  location.replace(url)
}

export function* getTemplateTeamsWatcher(action){
  try {
    yield call(messageProgress, "Descargando plantilla")
    yield call(getTemplateTeamsApi, action.payload)
    let data 
    while(true){
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getTemplateTeamsApiProgress)

      if(data.status === 200) {
        break
      }
    }
    yield call(donwloadTemplateTeams, data.data[0].url)
    yield call(messageDestroy)
    yield call(messageSuccess, getStatusCollaboratorTeamsImport("Plantilla descargada"))
    yield put(getTemplateTeamsSuccess())
  } catch (error) {
    console.log(error)
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusExportCollaborator("Error al descargar la plantilla")
    )
    yield put(getTemplateTeamsFailed())
  }
}

export function* getTemplateCollaboratorsWatcher(action) {
  try {
    yield call(messageProgress, "Descargando plantilla")

    yield call(getTemplateCollaboratorsApi, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getTemplateCollaboratorsApiProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(donwloadTemplateCollaborators, data.data[0].url)
    yield call(messageDestroy)
    yield call(
      messageSuccess,
      getStatusExportCollaborator("Plantilla descargada")
    )
    yield put(getTemplateCollaboratorsSuccess())
  } catch (error) {
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusExportCollaborator("Error al descargar la plantilla")
    )
    yield put(getTemplateCollaboratorsFailed())
  }
}

function getStatusExportCollaborator(status) {
  exportCollaboratorSegment(status, "exportEmployeeTemplate")
  return status
}

// UPLOAD EXCEL
function uploadTemplateCollaborators(payload) {
  woopraTrack("Importar Archivo Colaboradores")
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateCollaboratorsProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

export function* uploadTemplateCollaboratorsWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    let data_response = yield call(uploadTemplateCollaborators, action.payload)
    setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT, data_response.data.timestamp)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateCollaboratorsProgress, {
        timestamp: data_response.data.timestamp,
      })

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateCollaboratorsSuccess())
    yield put(push("/organization/collaborators/summary?screen=collaborators"))
  } catch (error) {
    yield put(uploadTemplateCollaboratorsFailed())
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusCollaboratorImport("Error al importar archivo")
    )
  }
}

function getStatusCollaboratorImport(status) {
  importCollaboratorSegment(status, "importFailedEmployee", "")
  return status
}

// GET TEMPLATE CEASED
export function getTemplateCeasedApi(isTemplate) {
  const template = isTemplate ? "/template" : ""
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/export/xlsx${template}`,
  })
}

export function getTemplateDivisionsAssignmentApi(isTemplate) {
  const template = isTemplate ? "/template" : ""
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/export/xlsx${template}`,
  })
}

function getTemplateCeasedApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/export/xlsx/progress`,
  })
}


function getTemplateDivisionsAssignmentApiProgress() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/export/xlsx/progress`,
  })
}



function donwloadTemplateCeased(url) {
  location.replace(url)
}

function downloadTemplateDivisionsAssignment(url) {
  location.replace(url)
}

function donwloadTemplateTeams(url) {
  location.replace(url)
}

export function* getTemplateCeasedWatcher(action) {
  try {
    yield call(messageProgress, "Descargando plantilla")

    yield call(getTemplateCeasedApi, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getTemplateCeasedApiProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(donwloadTemplateCeased, data.data[0].url)
    yield call(messageDestroy)
    yield call(
      messageSuccess,
      getStatusCollaboratorCeasedImport("Plantilla descargada")
    )
    yield put(getTemplateCeasedSuccess())
  } catch (error) {
    yield call(messageDestroy)
    yield call(
      messageFailed,
      getStatusCollaboratorCeasedImport("Error al descargar la plantilla")
    )
    yield put(getTemplateCeasedFailed())
  }
}

export function* getTemplateDivisionsAssignmentWatcher(action) {
  try {
    yield call(messageProgress, "Descargando plantilla")
    yield call(getTemplateDivisionsAssignmentApi, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))
      data = yield call(getTemplateDivisionsAssignmentApiProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(downloadTemplateDivisionsAssignment, data.data[0].url)
    yield call(messageDestroy)
    yield call(messageSuccess, "Plantilla descargada")
    yield put(getTemplateDivisionsAssignmentSuccess())
  } catch (error) {
    yield call(messageDestroy)
    yield call(messageFailed, "Error al descargar la plantilla")
    yield put(getTemplateDivisionsAssignmentFailed())
  }
}

function getStatusCollaboratorTeamsImport(status) {
  exportCollaboratorSegment(status, "exportTeamsTemplate")
  return status
}

function getStatusCollaboratorCeasedImport(status) {
  exportCollaboratorSegment(status, "exportCeasedTemplate")
  return status
}

// UPLOAD EXCEL CEASED
function uploadTemplateCeased(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateCeasedProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

function uploadTemplateDivisionsAssignmentProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

function uploadTemplateDivisionsAssignmentApi(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

export function* uploadTemplateCeasedWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    yield call(uploadTemplateCeased, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateCeasedProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateCeasedSuccess())
    yield put(push("/organization/collaborators/summary?screen=ceased"))
  } catch (error) {
    yield put(uploadTemplateCeasedFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}

export function* uploadTemplateDivisionsAssignmentWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    const data_response = yield call(uploadTemplateDivisionsAssignmentApi, action.payload)
    setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT, data_response.data.timestamp)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateDivisionsAssignmentProgress, {
        timestamp: data_response.data.timestamp,
      })

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateDivisionsAssignmentSuccess())
    yield put(push("/organization/collaborators/summary?screen=divisions-assignment"))
  } catch (error) {
    console.log(error)
    yield put(uploadTemplateDivisionsAssignmentFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar el archivo")
  }
}
  
  
// UPLOAD EXCEL TEAMS
function uploadTemplateTeams(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateTeamsProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}
export function* uploadTemplateTeamsWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    let data_response = yield call(uploadTemplateTeams, action.payload)
    setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT, data_response.data.timestamp)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateTeamsProgress, {
        timestamp: data_response.data.timestamp,
      })

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateTeamsSuccess())
    yield put(push("/organization/collaborators/summary?screen=teams"))
  } catch (error) {
    console.log(error)
    yield put(uploadTemplateTeamsFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar el archivo")
  }
}

export default function* getDivisionWatcherSaga() {
  yield takeLatest(UPLOAD_TEMPLATE_CEASED_WATCHER, uploadTemplateCeasedWatcher)
  yield takeLatest(GET_TEMPLATE_CEASED_WATCHER, getTemplateCeasedWatcher)
  yield takeLatest(UPLOAD_TEMPLATE_TEAMS_WATCHER, uploadTemplateTeamsWatcher)
  yield takeLatest(
    GET_TEMPLATE_COLLABORATORS_WATCHER,
    getTemplateCollaboratorsWatcher
  )
  yield takeLatest(GET_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER, getTemplateDivisionsAssignmentWatcher)
  yield takeLatest(
    GET_TEMPLATE_TEAMS_WATCHER,
    getTemplateTeamsWatcher
  )
  yield takeLatest(
    UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
    uploadTemplateCollaboratorsWatcher
  )
  yield takeLatest(UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER, uploadTemplateDivisionsAssignmentWatcher)
}
